module.exports = __webpack_public_path__ + "img/cb19d8c.svg";